module.exports = __webpack_public_path__ + "img/laneige.b827f60a.svg";